import { Module } from 'vuex';

export interface PageState {
  pageHidden: boolean;
  pageFocus: boolean;
}

const state: PageState = {
  pageHidden: false,
  pageFocus: false,
};

const mutations = {
  setPageHidden(state: PageState, payload: boolean) {
    state.pageHidden = payload;
  },
  setPageFocus(state: PageState, payload: boolean) {
    state.pageFocus = payload;
  },
};

const actions = {
  setPageHidden({ commit }: any, payload: boolean) {
    commit('setPageHidden', payload);
  },
  setPageFocus({ commit }: any, payload: boolean) {
    commit('setPageFocus', payload);
  },
};

const getters = {
  pageHidden: (state: PageState) => state.pageHidden,
  pageFocus: (state: PageState) => state.pageFocus,
};

const pageState: Module<PageState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default pageState;
